import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import { sliceText } from '../../utils'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import { styles } from '../styles'

const GroupChatView = ({
  classes,
  channels,
  setConversationId,
  setRef,
  activeIndex,
  isLoaded,
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.conversations}>
        <div className={classes.scroll}>
          {channels && channels.length
            ? channels.map((channel, index) => {
                const { id, subject, lastMessage, date } = channel
                return (
                  <div
                    key={id}
                    className={classNames(classes.conversationWrapper, {
                      [classes.conversationWrapperActive]:
                        activeIndex === index,
                    })}
                    onClick={() => setConversationId(id, index)}
                    cypress_id={'conversationWrapperInChannelsTab'}
                  >
                    <div className={classes.conversation}>
                      <div className={classes.img} />
                      <div className={classes.textWrapper}>
                        <div className={classes.title}>{subject}</div>
                        <div className={classes.message}>
                          {lastMessage
                            ? lastMessage === '[file]'
                              ? lastMessage
                              : sliceText(lastMessage)
                            : ''}
                        </div>
                        <div className={classes.date}>{date}</div>
                      </div>
                    </div>
                  </div>
                )
              })
            : null}
        </div>
      </div>
      <div className={classes.chat}>
        <div style={{ height: 'calc(90vh - 126px)' }} ref={c => setRef(c)}>
          {!isLoaded && <LoadingIndicator />}
        </div>
      </div>
    </div>
  )
}

export default injectStyles(styles)(GroupChatView)
